import { orderXClient } from '@/service/client'
import { InstrumentList } from '@/types/generated/common/types'
import { MasterInstrumentListRequest } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchMasterInstrumentList(payload: MasterInstrumentListRequest) {
  try {
    const { data } = await orderXClient.post<{ instrumentList?: InstrumentList }>('/api', {
      masterInstrumentList: payload,
    })
    const instrumentListResponse = data.instrumentList
    if (!instrumentListResponse) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch master instrument list',
      })
    }
    return instrumentListResponse as InstrumentList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
